export function detectDeviceType(): string {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera || ''
  const width = window.innerWidth

  if (/android/i.test(ua)) {
    return 'android'
  }

  if (/iPad|iPhone|iPod/.test(ua)) {
    return 'ios'
  }

  if (width <= 768) {
    return 'mobile'
  }

  if (width <= 1200) {
    return 'tablet'
  }

  return 'desktop'
}
